// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

body {
  /* overflow: hidden; */
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.forgot-password {
  margin-top: 10px; /* Adjust the top margin as needed */
}

.forgot-link {
  color: #007bff; /* Change link color if needed */
  text-decoration: none; /* Remove underline */
}

.forgot-link:hover {
  text-decoration: underline; /* Underline on hover */
}

html{
  width: 100%;
  -webkit-text-size-adjust: 100%;
  font-feature-settings: normal;
  font-family: Source Sans Pro,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji !important;
}

#root {
  font-family: Source Sans Pro,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
  
}
.forgot-password {
  margin-top: 10px; /* Adjust the top margin as needed */
}

.forgot-link {
  color: #007bff; /* Change link color if needed */
  text-decoration: none; /* Remove underline */
}

.forgot-link:hover {
  text-decoration: underline; /* Underline on hover */
}


@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


/*
  Common Styles
*/
.container {
    position: relative;
    height: 100vh;
    width: 100%;
}

/*
Styles for header
*/

.styles-for-dropdown {
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.rounded-xl {
  border-radius: .75rem
}
.border {
  border-width: 1px
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246/var(--tw-border-opacity))
}
.transform {
  transform: translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
}

.top-1\\/2 {
  top: 27%;
}

.left-2\\.5 {
  left: 0.625rem;
}
.absolute {
  position: absolute;
}

.border-l {
  border-left-width: 2px;
}

.border-r {
  border-right-width: 2px;
}

.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246/var(--tw-border-opacity));
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.items-center {
  align-items: center;
}
.w-full {
  width: 85%;
}
.h-16 {
  height: 4rem;
}
.flex {
  display: flex;
}

.items-center {
  align-items: center;
}
.flex-1 {
  flex: 1 1;
}
.lg\\:block {
  display: block;
}

.md\\:block {
  display: block;
}

.font-bold {
  font-weight: 700;
}
.text-lg {
  font-size: 1.8rem;
  line-height: 1.75rem;
}

.lg\\:max-w-sm {
  max-width: 24rem;
}
.lg\\:mr-6 {
  margin-right: 1.5rem;
}
.flex-1 {
  flex: 1 1;
}
.mr-2 {
  margin-right: 0.5rem;
  margin-left: 1.5rem;
}
.relative {
  position: relative;
}
.border-b{
  border-bottom-width: 2px;
}

.pr-3 {
  padding-right: 0.75rem;
}
.pl-8 {
  padding-left: 2rem;
}
/* .w-full {
  width: 100%;
} */
.h-9 {
  height: 2.25rem;
}

.form-input-alt, .form-input-alt:focus {
  --tw-shadow: inset 0 2px 4px 0 rgba(0,0,0,.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
}
.form-input-alt {
  outline: 2px solid transparent;
  outline-offset: 2px;
  box-sizing: border-box;
  border: 0 solid #e5e7eb;
}
.form-input-alt {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235/var(--tw-border-opacity));
  border-radius: 0.5rem;
  border-width: 1px;
  height: 2.3rem;
  padding-left: 2rem;
  padding-right: 0.75rem;
}

.lg\\:block {
  display: block;
}

.ml-auto {
  margin-left: auto;
}

.items-center {
  align-items: center;
}

.flex {
  display: flex;
}
menu, ol, ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.py-0\\.5 {
  padding-bottom: 0.125rem;
  padding-top: 0.125rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.items-center {
  align-items: center;
}
.flex {
  display: flex;
}
a {
  color: inherit;
  text-decoration: inherit;
}

.mr-1\\.5 {
  margin-right: 0.375rem;
}
.space-x-2>:not([hidden])~:not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-left: calc(1rem*(1 - var(--tw-space-x-reverse)));
  margin-right: calc(1rem*var(--tw-space-x-reverse));
}

*, :after, :before {
  border: 0 solid #e5e7eb;
  box-sizing: border-box;
}


/* header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  background-color: #333;
  color: #fff;
  padding: 0 20px;
}

.header-left {
  display: flex;
  align-items: center;
  width: 20%;
}

form {
  display: flex;
  width: 100%;
}

/* input[type="text"] {
  border: none;
  background-color: #eee;
  padding: 10px;
  font-size: 16px;
  border-radius: 5px 0 0 5px;
  width: inherit;
} */

/* button[type="submit"] {
  background-color: #f90;
  color: #fff;
  border: none;
  padding: 10px;
  font-size: 16px;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
}

ul {
  display: flex;
  list-style: none;
}

li {
  padding: 0 15px;
}

a {
  color: #fff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
} */ */

/*
Styles for Benchmarks page
*/

.page-container {
  display: grid;
  grid-template-columns: 15% 65% 20%;
  width: 100%;
}

.left-nav, .main-content, .main-content-no-scroll, .right-rail {
  height: auto;
}

.left-nav {
  position: sticky;
  top: var(--left-nav-top-offset, 0px);
  max-height: calc(100vh - var(--left-nav-top-offset, 0px));
  
  overflow-y: auto;
  scrollbar-width: thin;
  height: 100vh;
}

.main-content {
  padding: 15px;
  overflow-y: scroll;
  min-height: 100vh;
}

.main-content-no-scroll  {
  padding: 15px;
  overflow-y: auto;
  min-height: 100vh;
}

.right-rail-container {
  margin-right: 12px;
  background: #f8f9fa;
  min-height: 100vh;
}

.search-window {
  /* border: 1px solid black; */
  padding: 15px 15px 2px 15px;
  /* background-color: lightgrey; */
  /* border-bottom: none; */
}

.updates-container{
  display: grid;
  grid-template-columns: 20% 60% 20%;
  width: 100%;
}

.getStarted-container, 
.page-container{
  display: grid;
  grid-template-columns: 15% 65% 20%;
  width: 100%;  
}

.competition-container,
.page-container {
  display: grid;
  grid-template-columns: 15% 65% 20%;
  width: 100%;
}

.benchmarks-container,
.page-container {
  display: grid;
  grid-template-columns: 15% 65% 20%;
  width: 100%;
}

.doc-container, 
.page-container {
  display: grid;
  grid-template-columns: 15% 65% 20%;
  width: 100%;
}

.btn {
  --tw-border-opacity: 1;
  --tw-gradient-from: #fff;
  --tw-gradient-to: hsla(0,0%,100%,0);
  --tw-gradient-stops: var(--tw-gradient-from),var(--tw-gradient-to);
  --tw-gradient-to: #f3f4f6;
  --tw-text-opacity: 1;
  border-color: rgb(229 231 235/var(--tw-border-opacity));
  /* color: rgb(31 41 55/var(--tw-text-opacity)); */
}

/* .w-full {
  width: 100%;
} */

.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175/var(--tw-text-opacity));}

.mr-1\\.5 {
    margin-right: 0.375rem;
}

.grid-cols-2 {
  grid-template-columns: repeat(2,minmax(0,1fr));
}

.grid {
  display: grid;
}

.content-start {
  align-content: flex-start;
}

.gap-2\\.5 {
  gap: 0.625rem;
}

.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0/var(--tw-text-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255/var(--tw-bg-opacity));
}
.flex-col {
  flex-direction: column;
}
.min-h-screen {
  min-height: 100vh;
}
.flex {
  display: flex;
}
.inside-body {
  line-height: inherit;
  margin: 0;
}

.contents {
  display: contents;
}

.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246/var(--tw-border-opacity));
}
.border-y {
  border-bottom-width: 1px;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.items-center {
  align-items: center;
}

.h-16 {
  height: 4rem;
}

.container {
  margin-left: auto;
  margin-right: auto;
  /* padding-left: 1rem;
  padding-right: 1rem; */
  width: 100%;
}

.flex-1 {
  flex: 1 1;
}

.flex-none {
  flex: none;
}

.mr-5 {
  margin-right: 1.25rem;
}
a {
  color: inherit;
  text-decoration: inherit;
}


/*
Styles for Right Rail
*/

.display-flex .text-container {
  padding-left: 3px;
  padding-top: 2px;
}

.results-window .font-size {
  font-size: 12px;
}

.display-flex {
  display: flex;
}
.display-flex p{
margin: 0px;}

.time-stamp-display {
  float: left;
  font-size: 12px;
  padding-left: 28px;
}

.right-rail-search-svg {
  padding: 5px;
  
}

.right-side-of-container svg {
  padding-right: 20px;
}

.row5-search-window svg {
  padding-right: 20px;
}
.row3-search-window {
  padding-bottom: 25px !important;
}
.row5-search-window {
  background-color: #dee2e6!important;
}

.row1-search-window, .row3-search-window, .row4-search-window, .row5-search-window {
  display: flex;
  justify-content: space-between;
}

.storage-span {
  margin-top: 4px;
}

.results-window{
  /* border: 1px solid black; */
  height: 480px
}

svg {
  cursor: pointer;
  vertical-align: middle;
  /* --tw-text-opacity: 1;
    color: rgb(156 163 175/var(--tw-text-opacity)); */
}

.svg-inline--fa {
  height: 0.8rem;
  color: #25537b;
  font-weight: 400;
}

.right-container {
  position: sticky;
    top: 0;
}

.rightpane-text {
  color: #2c3143;
    font-weight: 400;
    line-height: 1.2;
}

.rightpane-text-history {
  font-size: 1.0625rem;
  font-weight: 500;
}

.rightpane-text-unnamed-history {
  font-size: 1.275rem;
}

/* .row5-search-window .left-side-of-container, .row4-search-window .left-side-of-container{
  padding-left: 0.8rem;
} */
.row1-search-window .left-side-of-container{
  padding-top: 5px;
}

.row3-search-window .left-side-of-container{
  padding-top: 3px;
}

.row4-search-window .left-side-of-container{
  display: flex;
}

.rightpane-1 svg:hover {
  background-color: #c8cfd6;
}

/* .rightpane-1 svg{
  padding: 10px;
} */

.rightpane-1 svg:not(.search-icon-svg) {
  padding: 10px;
}

.input-group {
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
}

.input-group .form-control {
  flex: 1 1 auto;
  margin-bottom: 0;
  min-width: 0;
  position: relative;
  width: 1%;
  font-size: .85rem;
  line-height: 1.5;
  background-clip: padding-box;
  background-color: #fff;
  border: 1px solid #bdc6d0;
  color: #2c3143;
  display: block;
}

.form-control-sm {
  border-radius: 0.2rem;
  font-size: .74375rem;
  height: 22px;
  line-height: 1.5;
  padding: 0.25rem 0.5rem;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-append, .input-group-prepend {
  display: flex;
}
.btn-secondary{
  border: 1px solid #bdc6d0;
  padding: 7px;
  cursor: pointer;
}
.rows-search-window {
  padding-bottom: 5px;
}

.btn-secondary:hover{
  background-color: #c8cfd6;
}

.alert-info, .form-help .note, .infomessage, .infomessagelarge, .infomessagesmall {
  background: #daecf8!important;
}

.alert-info{
  border-color: transparent;
  color: #2a3f59;
}
.alert {
  border: 1px solid transparent;
    border-radius: 0.25rem;
    margin-bottom: 1rem;
    padding: 0.75rem 1.25rem;
    position: relative;
}
.m-2 {
  margin: 0.5rem!important;
}
.results-window h4 {
  margin: 5px;
}

.results-window p {
font-size: 14px;}
/*
Styles for Login page

*/


.form-input:not([type=radio]):not([type=checkbox]) {
  border-radius: 0.375rem;
  display: block;
  margin-top: 0.25rem;
  width: 100%;
}

.form-input:not([type=checkbox]) {
  --tw-shadow: 0 1px 2px 0 rgba(0,0,0,.05);
  --tw-shadow: 0 1px 2px 0 rgba(0,0,0,.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235/var(--tw-border-opacity));
  border-width: 2px;
  --tw-ring-shadow: 0 0 #0000;
    
}

.auth-form-container a {
  color: #169BD5;
  text-decoration: none;
  font-size: small;
}

.comn-container-auth{
    position: absolute;
    z-index: 899;
    left: 25%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 50%;
    margin-top: 50px;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
}

.comn-container-auth p {
  margin-bottom: 30px !important;
}

.comn-container-auth h1, .comn-container-auth p {
  margin-bottom: 20px;
  text-align: center;
}

.comn-container-auth label {
  display: block;
  margin-bottom: 5px;
  margin-top: 20px;
}

.comn-container-auth input[type="checkbox"] {
  height: 13px;
}

.comn-container-auth input{
  display: block;
  /* margin-bottom: 25px; */
  height: 35px;
  border-radius: 6px;
  border: 1px solid;
  width: 100%;
  padding: 0.2rem 0.5rem;
}

/* .comn-container-auth button {
  margin-top: 25px;
  margin-top: 10px;
  margin: 25px 0px 0px 80px;
  height: 45px;
  border-radius: 6px;
  border: 1px solid;
  width: 40%;
} */
.comn-container-auth button {
  --tw-border-opacity: 1;
  --tw-gradient-from: #fff;
  --tw-gradient-to: hsla(0,0%,100%,0);
  --tw-gradient-stops: var(--tw-gradient-from),var(--tw-gradient-to);
  --tw-gradient-to: #f3f4f6;
  --tw-text-opacity: 1;

}
.btn-widget {
  border-color: rgb(229 231 235/var(--tw-border-opacity));
  color: rgb(31 41 55/var(--tw-text-opacity));
  width: 100%;
  align-items: center;
  /* background-image: linear-gradient(to bottom,var(--tw-gradient-stops)); */
  border-radius: 0.5rem;
  border-width: 1px;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  padding: 1rem 0.75rem;
  -webkit-user-select: none;
  user-select: none;
  white-space: nowrap;
  margin-top: 2rem !important;

}


.comn-container-auth form {
  flex-direction: column;
}

.inner-container-auth{
  width: 40%;
}

.clear-icon {
    position: absolute;
    right: 12px !important;
    top: 8px !important;
    cursor: pointer;
}
.checkbox-container {
  display: flex;
}

.checkbox-container a {
  padding-left: 55px;
}

.checkbox-container label {
  margin-top: -3px;
  margin-bottom: 0px;
}

.span-class-link {
  color: #169BD5;
  cursor: pointer;
  font-size: small;
}

.checkbox {
  display: flex;
  margin-top: 1rem;
}

.checkbox input[type="checkbox"] {
  margin-right: 5px;
  width: auto;
}

.checkbox label {
  margin-top: -2px;
}

.checkbox span{
  margin-left: 3rem;
}




/* Styles for team Page */

.img-responsive {
  display: block;
  height: auto;
  width: 180px;
  height: 181px;
}

.team-page-container a {
  color: #169BD5;
}

.image-container p {
  margin: 2px;
}

.team-page-container h3 {
  font-size: 34px;
  margin-top: 20px;
  margin-bottom: 0px;
}
.team-page-container h1 {
  font-size: 56px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.team-page-container h1, .team-page-container h3 {
  color: #444;
}

.member-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 230px; 
  padding: 20px;
  border-top: 1px solid #ccc;
}

.member-image {
  width: 155px;
  height: auto;
  object-fit: cover;
  margin-bottom: 20px;
}

.member-details {
  text-align: center;
}

.member-name {
  font-weight: bold;
  margin-bottom: 10px;
}

.member-organization {
  font-size: 1rem;
}

.core-team-container, .steering-team-container {
  display: flex;
  flex-wrap: wrap;
}

.steering-committee-header3 {
  margin-bottom: 15px !important;
}



/* Styles for Nav Links */

.hide {
  display: none;
}

ul.ul-suboptions {
  display: list-item;
  /* background-color: #333; */
  padding: 2px;
  /* margin-left: -24px; */
}
ul.ul-suboptions li {
  padding: 10px 20px;
  text-align: center;
  max-width: 10rem;
}
ul.ul-suboptions li:hover {
  background-color: rgba(128, 128, 128, 0.06);
  text-decoration: underline;
  text-decoration-color: black;
}

.suboptions-container {
  position: absolute;
  z-index: 1999;
  background-color: white;
}

ul li:hover > ul {
  display: list-item !important;
}

/* Styles for Main-content */

.main-content img{
  max-width: 95%;
  max-height: 100%;
}
/* .main-content h2{
  text-align: center;
} */

.main-content a{
  color: #111849;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
}

.main-content li{
  list-style-type: disc;
}
.main-content ul{
  list-style-type: disc;
  padding-left: 3rem;
}

.main-content code {
  font-size: 85%;
  /* background-color: rgba(175, 184, 193, 0.2); */
  padding: 0.2em 0.4em;
  margin: 0px;
  border-radius: 6px;
  font-family: monospace;
  font-size: 12px;

}

.main-content pre {
  font-size: 85%;
  line-height: 1.45;
  background-color: rgb(246, 248, 250);
  overflow-wrap: normal;
  padding: 16px;
  overflow: auto;
  border-radius: 6px;
  display: block;
  font-family: monospace;
  white-space: pre;
  margin: 1em 0px;
}


/* Preview Datasets */

.main-content code{
  font-size: 14px;
  }
  /* .copy-to-clipboard-button {
    position: absolute;
    right: 0;
    top: 0;
    visibility: hidden;
  } */
  .preview-dataset-container span.fu {
    color: #06287e;
} 


.main-content-no-scroll img {
  max-width: 95%;
  max-height: 100%;
  align-items: center;
  justify-content: center;
}

/* .main-content-no-scroll h2{
  text-align: center;
} */

.main-content-no-scroll a {
  color: #111849;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
}

.main-content-no-scroll li {
  list-style-type: disc;
}

.main-content-no-scroll ul {
  list-style-type: disc;
  padding-left: 3rem;
}

.main-content-no-scroll code {
  font-size: 85%;
  /* background-color: rgba(175, 184, 193, 0.2); */
  padding: 0.2em 0.4em;
  margin: 0px;
  border-radius: 6px;
  font-family: monospace;
  font-size: 12px;

}

.main-content-no-scroll pre {
  font-size: 85%;
  line-height: 1.45;
  background-color: rgb(246, 248, 250);
  overflow-wrap: normal;
  padding: 16px;
  overflow: auto;
  border-radius: 6px;
  display: block;
  font-family: monospace;
  white-space: pre;
  margin: 1em 0px;
}


/* Preview Datasets */

.main-content-no-scroll code {
  font-size: 14px;
}


/* .copy-to-clipboard-button {
    position: absolute;
    right: 0;
    top: 0;
    visibility: hidden;
  } */
.preview-dataset-container span.fu {
  color: #06287e;
}

.preview-dataset-container span.ot {
  color: #007020;
}

span.st {
  color: #4070a0;
}

span.at {
  color: #7d9029;
}

span.dv {
  color: #40a070;
}

span.sc {
  color: #4070a0;
}
    
/* Alerts */
.message-box{
  display: flex;
  position: absolute;
  z-index: 9998;
  left: 35%;
  /* display: inline; */
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 30%;
  margin-top: 50px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
}

/* Styles for
Updates Page */

.updates-div {
  margin: 20px 0px;
  border-top-width: 3px;
}


.getStarted-container .main-content img{
  align-items: center;
  justify-content: center;
}

.category {
  border-left-width: 4px;
  border-left-color: #e9ecef;
}

#root_clustering, #root_outliers, #root_tSNEAndFR, #root_extraParameters, #root_parameters {
  padding: 0px;
  margin: 0px;
}

#root_clustering legend, #root_outliers legend, #root_tSNEAndFR legend, #root_extraParameters legend, #root_parameters legend{
  background: #e9ecef  ;
  width: 100%;
  padding: 10px 10px;
  font-weight: bolder;
  color: #2c3143;
}

.tools-container .btn-info {
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
}

.tools-container .btn-danger {
  color: #fff;
  background-color: #d9534f;
  border-color: #d43f3a;
  /* padding: 6px 10px !important; */
}

.tools-container .btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
  /* flex: none !important; */
}

.tools-container .glyphicon {
  position: relative;
  top: 1px;
  display: inline-block;
  font-family: 'Glyphicons Halflings';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.tools-container .glyphicon-plus:before {
  content: "\\002b";
}

.tools-container .glyphicon-remove:before {
  content: "\\00d7";
}

.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
  border-radius: 0;
}
.btn-group .btn+.btn, .btn-group .btn+.btn-group, .btn-group .btn-group+.btn, .btn-group .btn-group+.btn-group {
  margin-left: -1px;
}
.btn-group-vertical>.btn.active, .btn-group-vertical>.btn:active, .btn-group-vertical>.btn:focus, .btn-group-vertical>.btn:hover, .btn-group>.btn.active, .btn-group>.btn:active, .btn-group>.btn:focus, .btn-group>.btn:hover {
  z-index: 2;
}

.btn-default:hover {
  color: #333;
  background-color: #e6e6e6;
  border-color: #adadad;
}
.btn.focus, .btn:focus, .btn:hover {
  color: #333;
  text-decoration: none;
}
.btn-default {
  color: #333;
  background-color: #fff;
  border-color: #ccc !important;
}
.glyphicon-arrow-down:before {
  content: "\\2193";
}
.glyphicon-arrow-up:before {
  content: "\\2191";
}

.tools-container .btn-danger:hover {
  color: #fff;
  background-color: #c9302c;
  border-color: #ac2925;
}

.sub-category {
  margin-left: 10px;
}
.field-object .form-subset {
  border-left-width: 4px;
  border-left-color: #e9ecef;
}

.field-object .form-subset fieldset{
  padding: 0px;
}

.field-object .form-subset legend{
  margin-left: -3px;
}
.control-label {
  font-weight: bolder;
}

.default-class {
  margin-left: 10px;
}

.default-class label{
  background: #e9ecef  ;
  width: 100%;
  padding: 10px 10px;
  font-weight: bolder;
}

.default-class select,
.default-class p{
  margin-left: 10px;
  width: 98.5% !important;
}

/* .field-description {
  padding-left: 10px;
} */

.common-class-tools-and-workflows .form-group {
  margin-bottom: 1rem;
  margin-top: 1rem;
}

.common-class-tools-and-workflows .form-component label {
  display: block;
  margin-bottom: 0.5rem;
}

.common-class-tools-and-workflows .form-component input,
.common-class-tools-and-workflows .form-component select,
.common-class-tools-and-workflows .form-component textarea {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
/* 
  .common-class-tools-and-workflows .form-component select.form-control {
    height: 40px;
  } */

  .common-class-tools-and-workflows .form-component select option {
    padding: 5px; /* Add some padding to each option */
    margin: 5px 0;
  }

  .common-class-tools-and-workflows .inputData-management .datasets-input-select ul {
    padding-left: 0px;
  }

  .datasets-input-select {
    width: 100%;
  }

  .datasets-input-select select {
    overflow: auto;
  }

  .common-class-tools-and-workflows .form-component input:focus,
  .common-class-tools-and-workflows .form-component select:focus,
  .common-class-tools-and-workflows .form-component textarea:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  .inputData-management {
    margin-left: 15px;
  }

  .inputData-management .icons-wrap-input {
    margin-right: 10px;
  }

  .inputData-management .icons-wrap-input button.database-icon-input{
    border: 1px solid #bdc6d0;
    padding: 7px 10px;
    margin-right: 5px;
  }
  .inputData-management .icons-wrap-input svg{
    /* background-color: rgb(218, 236, 248); */
    background-color: rgba(218, 236, 248, 0);
  }

  /* .inputData-management .icons-wrap-input{
    background-color: rgb(218, 236, 248);
    border-radius: 5px;
    border: 1px solid #bdc6d0;
  } */

  /* .inputData-management .icons-wrap-input button{
    background-color: rgb(218, 236, 248);
    border: 1px solid #bdc6d0;
    padding: 7px 10px;
    margin-left: -1px;
    cursor: pointer;
  } */
  .inputData-management button.input-path-button {
    padding: 7px 10px;
    background-color: #dee2e6;
    border-radius: 5px;
    border: 1px solid #bdc6d0;
  }

  .inputData-management button.input-path-button svg{
    background-color: #dee2e6;
  }

  .inputData-management #upload-data-div{
    background-color: rgb(218, 236, 248);
  }

  .inputData-management #upload-data-div select{
    background-color: rgb(218, 236, 248);
    display: block;
    float: none;
    margin-right: 26px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 94%;
    cursor: pointer;
  }

.ui-form-title-message {
    color: #545e81;
    cursor: default;
    font-size: .595rem;
    font-weight: 300;
    vertical-align: text-top;
}

  .inputData-management .wrap-div-row {
    display: flex;
  }

  .inputData-management .common-row-wrap {
    padding-top: 2px;
    }

  .common-class-tools-and-workflows .form-component button[type="submit"] {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
    display: inline-block;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  .common-class-tools-and-workflows .form-component button[type="submit"]:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc;
  }
  .common-class-tools-and-workflows .separator, .upload-task .separator{
    align-items: center;
    display: grid;
    grid-template-columns: 1rem auto 1fr;
    margin-bottom: 0.5rem;
    gap: 1rem;
  }

  .common-class-tools-and-workflows .separator .stripe, .upload-task .separator .stripe {
    background-color: rgb(222, 226, 230);
    display: block;
    height: 1px;
}

.common-class-tools-and-workflows .h-sm, .upload-task .h-sm {
  line-height: 1.2;
  font-weight: 700;
  font-size: 1.0625rem;
}



.panel-icons {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  gap: 5px;
  height: 100%;
  padding: 10px;
  font-size: 20px;
}

.panel-icons svg {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

/* .tool-panel-section {
  padding-bottom: 0.25rem;
  padding-left: 0.75rem;
  padding-top: 0.25rem;
} */

/* 
.tool-panel-section h3 {
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  background: rgb(233, 236, 239);
  border-left: 0.25rem solid rgb(174, 185, 197);
} */

.category-level-header {
  padding: 10px 0px 10px 15px;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  background: rgb(233, 236, 239);
  border-left: 0.25rem solid rgb(174, 185, 197);
  margin: 0px;
  cursor: pointer;
}

/* .filter-level-ul {
  padding: 0px 0px 0px 15px;
} */

.category-level {
  margin-bottom: 20px;
}

li.filter-level-li {
  padding: 11px 0px;
  padding-left: 40px;
  word-break: break-word;
  cursor: pointer;
}

.category-icon {
  float: right;
  margin-right: 10px;
}

/* .category-filters {
  overflow: hidden;
  transition: all 5s ease-in-out;
  max-height: 0;
  opacity: 0;
}

.category-filters.expanded {
  max-height: 500px;
  opacity: 1;
} */


/* Define the animation */
@keyframes expand {
  0% {
    height: 0;
    opacity: 0;
  }
  100% {
    height: 50px;
    opacity: 1;
  }
}

/* Apply the animation to the ul element */
.filter-level-ul {
  overflow: hidden;
  animation: expand 0.2s ease-out;
}

.category-level-header:hover {
  background-color: #e0e0e0;
}

.filter-level-li:hover {
  background-color: #f0f0f0;
}

width
::-webkit-scrollbar {
  width: 10px;
}

/* ::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
::-webkit-scrollbar-thumb {
  background: #888; 
}

::-webkit-scrollbar-thumb:hover {
  background: #555; 
} */

.left-nav-background {
  background: #f8f9fa;
}

.tool-message {
  padding: 10px;
}

/* .filter-details-tools {
  margin: 10px 20px 10px 10px;} */


  
.expandable {
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 10px;
}

.header {
  background-color: #f5f5f5;
  padding: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.arrow {
  display: inline-block;
  width: 20px;
  text-align: center;
  transition: transform 0.3s;
}

.arrow.expanded {
  transform: rotate(90deg);
}

.title {
  margin-left: 5px;
}

.content {
  padding: 10px;
  animation: slide-down 0.3s ease;
}

@keyframes slide-down {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.hoverable-icon {
  position: relative;
  display: inline-block;
  background-color: transparent;
  color: black;
  border-radius: 50%;
  padding: 5px;
  transition: background-color 0.3s ease;
}

.hoverable-icon:hover {
  background-color: lightgrey;
}


.publish-dataset-div .toggle-switch {
  position: relative;
  width: 75px;
  display: inline-block;
  text-align: left;
  top: 8px;
}
.publish-dataset-div .checkbox {
  display: none;
}
.publish-dataset-div .label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 0 solid #bbb;
  border-radius: 20px;
}
.publish-dataset-div .inner {
  display: block;
  width: 200%;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;
}
.publish-dataset-div .inner:before,
.publish-dataset-div .inner:after {
  float: left;
  width: 50%;
  height: 36px;
  padding: 0;
  line-height: 36px;
  color: #fff;
  font-weight: bold;
  box-sizing: border-box;
}
.publish-dataset-div .inner:before {
  content: "YES";
  padding-left: 10px;
  background-color: #060;
  color: #fff;
}
.publish-dataset-div .inner:after {
  content: "NO";
  padding-right: 10px;
  background-color: #bbb;
  color: #fff;
  text-align: right;
}
.publish-dataset-div .switch {
  display: block;
  width: 24px;
  margin: 5px;
  background: #fff;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 40px;
  border: 0 solid #bbb;
  border-radius: 20px;
  transition: all 0.3s ease-in 0s;
}
.publish-dataset-div .checkbox:checked + .label .inner {
  margin-left: 0;
}
.publish-dataset-div .checkbox:checked + .label .switch {
  right: 0px;
}


#dashFrame{
  height: 100vh;
}


.eighty-twenty-grid {
  display: grid;
  grid-template-columns: 80% 20%;
}



.eighty-twenty-grid .main-content{
  margin-left: 4rem;
}

.eighty-twenty-grid .main-content .task-builder-task{
  margin-top:2rem;
}

.eighty-twenty-grid .main-content-no-scroll .task-builder-task {
  margin-top: 2rem;
}

/* popupmodal.css */
.session-manager-component .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 995;
}

.session-manager-component .modal-content {
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 400px;
  max-width: 90%;
  height: inherit;
}

.session-manager-component .modal-message {
  font-size: 18px;
  line-height: 1.5;
  margin: 0 0 20px;
}

.session-manager-component .modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.session-manager-component .modal-button {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
}

.session-manager-component .modal-button.no {
  background: #f44336;
}


.MuiTypography-h6,.MuiTypography-body1  {
  font-size: 15px !important;
}




/* Live logs */

.text-red-500 {
  color: #EF4444; 
}

.text-yellow-400 {
  color: #FACC15; 
}

.text-green-500 {
  color: #22C55E;
}



/* .dark-bg {
  background-color: #1F2937;
}

.flex-center {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
}

.title {
  font-size: 1.875rem; 
  color: #D1D5DB; 
}

.log-box {
  display: block;
  width: 100%;
  padding: 0.625rem; 
  font-size: 0.875rem; 
  color: #1F2937; 
  background-color: #F9FAFB;
  border-radius: 0.375rem; 
  border: 1px solid #E5E7EB;
}

.log-box:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  border-color: #3B82F6; 
}

.dark .dark-bg {
  background-color: #374151;
}

.dark .log-box {
  background-color: #374151; 
  border-color: #4B5563; 
  color: #F9FAFB; 
} */`, "",{"version":3,"sources":["webpack://./src/components/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB,EAAE,oCAAoC;AACxD;;AAEA;EACE,cAAc,EAAE,gCAAgC;EAChD,qBAAqB,EAAE,qBAAqB;AAC9C;;AAEA;EACE,0BAA0B,EAAE,uBAAuB;AACrD;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,6BAA6B;EAC7B,4NAA4N;AAC9N;;AAEA;EACE,iNAAiN;;AAEnN;AACA;EACE,gBAAgB,EAAE,oCAAoC;AACxD;;AAEA;EACE,cAAc,EAAE,gCAAgC;EAChD,qBAAqB,EAAE,qBAAqB;AAC9C;;AAEA;EACE,0BAA0B,EAAE,uBAAuB;AACrD;;;AAGA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;;CAEC;AACD;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;;CAEC;;AAED;EACE,uBAAuB;EACvB,wCAAwC;AAC1C;AACA;EACE;AACF;AACA;EACE;AACF;AACA;EACE,sBAAsB;EACtB;AACF;AACA;EACE,8LAA8L;AAChM;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,SAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,SAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;;GAEG;AACH;EACE,eAAe;AACjB;;AAEA;EACE,8CAA8C;EAC9C,6DAA6D;EAC7D,mGAAmG;AACrG;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,uDAAuD;EACvD,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,uDAAuD;EACvD,kDAAkD;AACpD;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA4BG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;GA0BG,EAAE;;;;;;;EAOH,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,yDAAyD;;EAEzD,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,mCAAmC;EACnC,kEAAkE;EAClE,yBAAyB;EACzB,oBAAoB;EACpB,uDAAuD;EACvD,iDAAiD;AACnD;;AAEA;;GAEG;;AAEH;EACE,oBAAoB;EACpB,8CAA8C,CAAC;;AAEjD;IACI,sBAAsB;AAC1B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uDAAuD;AACzD;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB;wBACsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,wBAAwB;AAC1B;;;AAGA;;CAEC;;AAED;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;AACA;AACA,WAAW,CAAC;;AAEZ;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;;AAEd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB;qDACmD;AACrD;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;IACd,MAAM;AACV;;AAEA;EACE,cAAc;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;GAEG;AACH;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,6BAA6B;IAC3B,sBAAsB;IACtB,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;AACtB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;;AAEA;AACA,eAAe,CAAC;AAChB;;;CAGC;;;AAGD;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,uDAAuD;EACvD,mGAAmG;EACnG,kCAAkC;EAClC,sBAAsB;EACtB,uDAAuD;EACvD,iBAAiB;EACjB,2BAA2B;;AAE7B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;;;;;;GAQG;AACH;EACE,sBAAsB;EACtB,wBAAwB;EACxB,mCAAmC;EACnC,kEAAkE;EAClE,yBAAyB;EACzB,oBAAoB;;AAEtB;AACA;EACE,uDAAuD;EACvD,2CAA2C;EAC3C,WAAW;EACX,mBAAmB;EACnB,2EAA2E;EAC3E,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EAEzB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;;AAE7B;;;AAGA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;;;;AAKA,yBAAyB;;AAEzB;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;;;AAIA,yBAAyB;;AAEzB;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,4BAA4B;;AAE5B;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;GAEG;;AAEH;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;;AAEjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oCAAoC;EACpC,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;;AAGA,qBAAqB;;AAErB;EACE,eAAe;EACf;EACA;;;;;KAKG;EACH;IACE,cAAc;AAClB;;;AAGA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;GAEG;;AAEH;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;;AAEjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oCAAoC;EACpC,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;;AAGA,qBAAqB;;AAErB;EACE,eAAe;AACjB;;;AAGA;;;;;KAKK;AACL;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;cACc;;AAEd;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;;AAGA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EAEtB,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;EACjB,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;IAGI,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;IACtB,wEAAwE;EAC1E;AACF;;;KAGK;;EAEH;IACE,YAAY,EAAE,oCAAoC;IAClD,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;;;IAGE,qBAAqB;IACrB,UAAU;IACV,gDAAgD;EAClD;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,0CAA0C;IAC1C,wCAAwC;EAC1C;;EAEA;;;;KAIG;;EAEH;;;;;;KAMG;EACH;IACE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;IACpC,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,eAAe;EACjB;;AAEF;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB;;EAEF;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB;kEAC8D;EAChE;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,oCAAoC;IACpC,qBAAqB;IACrB,SAAS;EACX;;EAEA;IACE,oCAAoC;IACpC,cAAc;IACd,WAAW;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;;;AAIA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;GAIG;;AAEH;;;;;;;GAOG;;AAEH;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,6CAA6C;EAC7C,WAAW;EACX,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;;;;;;GAUG;;;AAGH,yBAAyB;AACzB;EACE;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;iCACiC;;;;AAIjC;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,kCAAkC;AACpC;AACA;;EAEE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;;AAGA;EACE,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,8BAA8B;AAChC;;;;AAIA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,0BAA0B;AAC5B;;;;;AAKA,cAAc;;AAEd;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAwCG","sourcesContent":[".App {\n  text-align: center;\n}\n\nbody {\n  /* overflow: hidden; */\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.forgot-password {\n  margin-top: 10px; /* Adjust the top margin as needed */\n}\n\n.forgot-link {\n  color: #007bff; /* Change link color if needed */\n  text-decoration: none; /* Remove underline */\n}\n\n.forgot-link:hover {\n  text-decoration: underline; /* Underline on hover */\n}\n\nhtml{\n  width: 100%;\n  -webkit-text-size-adjust: 100%;\n  font-feature-settings: normal;\n  font-family: Source Sans Pro,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji !important;\n}\n\n#root {\n  font-family: Source Sans Pro,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;\n  \n}\n.forgot-password {\n  margin-top: 10px; /* Adjust the top margin as needed */\n}\n\n.forgot-link {\n  color: #007bff; /* Change link color if needed */\n  text-decoration: none; /* Remove underline */\n}\n\n.forgot-link:hover {\n  text-decoration: underline; /* Underline on hover */\n}\n\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n/*\n  Common Styles\n*/\n.container {\n    position: relative;\n    height: 100vh;\n    width: 100%;\n}\n\n/*\nStyles for header\n*/\n\n.styles-for-dropdown {\n  background-color: white;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n.rounded-xl {\n  border-radius: .75rem\n}\n.border {\n  border-width: 1px\n}\n.border-gray-100 {\n  --tw-border-opacity: 1;\n  border-color: rgb(243 244 246/var(--tw-border-opacity))\n}\n.transform {\n  transform: translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n.-translate-y-1\\/2 {\n  --tw-translate-y: -50%;\n}\n\n.top-1\\/2 {\n  top: 27%;\n}\n\n.left-2\\.5 {\n  left: 0.625rem;\n}\n.absolute {\n  position: absolute;\n}\n\n.border-l {\n  border-left-width: 2px;\n}\n\n.border-r {\n  border-right-width: 2px;\n}\n\n.border-gray-100 {\n  --tw-border-opacity: 1;\n  border-color: rgb(243 244 246/var(--tw-border-opacity));\n}\n\n.px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.items-center {\n  align-items: center;\n}\n.w-full {\n  width: 85%;\n}\n.h-16 {\n  height: 4rem;\n}\n.flex {\n  display: flex;\n}\n\n.items-center {\n  align-items: center;\n}\n.flex-1 {\n  flex: 1 1 0%;\n}\n.lg\\:block {\n  display: block;\n}\n\n.md\\:block {\n  display: block;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n.text-lg {\n  font-size: 1.8rem;\n  line-height: 1.75rem;\n}\n\n.lg\\:max-w-sm {\n  max-width: 24rem;\n}\n.lg\\:mr-6 {\n  margin-right: 1.5rem;\n}\n.flex-1 {\n  flex: 1 1 0%;\n}\n.mr-2 {\n  margin-right: 0.5rem;\n  margin-left: 1.5rem;\n}\n.relative {\n  position: relative;\n}\n.border-b{\n  border-bottom-width: 2px;\n}\n\n.pr-3 {\n  padding-right: 0.75rem;\n}\n.pl-8 {\n  padding-left: 2rem;\n}\n/* .w-full {\n  width: 100%;\n} */\n.h-9 {\n  height: 2.25rem;\n}\n\n.form-input-alt, .form-input-alt:focus {\n  --tw-shadow: inset 0 2px 4px 0 rgba(0,0,0,.05);\n  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);\n}\n.form-input-alt {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n  box-sizing: border-box;\n  border: 0 solid #e5e7eb;\n}\n.form-input-alt {\n  --tw-border-opacity: 1;\n  border-color: rgb(229 231 235/var(--tw-border-opacity));\n  border-radius: 0.5rem;\n  border-width: 1px;\n  height: 2.3rem;\n  padding-left: 2rem;\n  padding-right: 0.75rem;\n}\n\n.lg\\:block {\n  display: block;\n}\n\n.ml-auto {\n  margin-left: auto;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.flex {\n  display: flex;\n}\nmenu, ol, ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.py-0\\.5 {\n  padding-bottom: 0.125rem;\n  padding-top: 0.125rem;\n}\n.px-2 {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n.items-center {\n  align-items: center;\n}\n.flex {\n  display: flex;\n}\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n.mr-1\\.5 {\n  margin-right: 0.375rem;\n}\n.space-x-2>:not([hidden])~:not([hidden]) {\n  --tw-space-x-reverse: 0;\n  margin-left: calc(1rem*(1 - var(--tw-space-x-reverse)));\n  margin-right: calc(1rem*var(--tw-space-x-reverse));\n}\n\n*, :after, :before {\n  border: 0 solid #e5e7eb;\n  box-sizing: border-box;\n}\n\n\n/* header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 70px;\n  background-color: #333;\n  color: #fff;\n  padding: 0 20px;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  width: 20%;\n}\n\nform {\n  display: flex;\n  width: 100%;\n}\n\n/* input[type=\"text\"] {\n  border: none;\n  background-color: #eee;\n  padding: 10px;\n  font-size: 16px;\n  border-radius: 5px 0 0 5px;\n  width: inherit;\n} */\n\n/* button[type=\"submit\"] {\n  background-color: #f90;\n  color: #fff;\n  border: none;\n  padding: 10px;\n  font-size: 16px;\n  border-radius: 0 5px 5px 0;\n  cursor: pointer;\n}\n\nul {\n  display: flex;\n  list-style: none;\n}\n\nli {\n  padding: 0 15px;\n}\n\na {\n  color: #fff;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n} */ */\n\n/*\nStyles for Benchmarks page\n*/\n\n.page-container {\n  display: grid;\n  grid-template-columns: 15% 65% 20%;\n  width: 100%;\n}\n\n.left-nav, .main-content, .main-content-no-scroll, .right-rail {\n  height: auto;\n}\n\n.left-nav {\n  position: sticky;\n  top: var(--left-nav-top-offset, 0px);\n  max-height: calc(100vh - var(--left-nav-top-offset, 0px));\n  \n  overflow-y: auto;\n  scrollbar-width: thin;\n  height: 100vh;\n}\n\n.main-content {\n  padding: 15px;\n  overflow-y: scroll;\n  min-height: 100vh;\n}\n\n.main-content-no-scroll  {\n  padding: 15px;\n  overflow-y: auto;\n  min-height: 100vh;\n}\n\n.right-rail-container {\n  margin-right: 12px;\n  background: #f8f9fa;\n  min-height: 100vh;\n}\n\n.search-window {\n  /* border: 1px solid black; */\n  padding: 15px 15px 2px 15px;\n  /* background-color: lightgrey; */\n  /* border-bottom: none; */\n}\n\n.updates-container{\n  display: grid;\n  grid-template-columns: 20% 60% 20%;\n  width: 100%;\n}\n\n.getStarted-container, \n.page-container{\n  display: grid;\n  grid-template-columns: 15% 65% 20%;\n  width: 100%;  \n}\n\n.competition-container,\n.page-container {\n  display: grid;\n  grid-template-columns: 15% 65% 20%;\n  width: 100%;\n}\n\n.benchmarks-container,\n.page-container {\n  display: grid;\n  grid-template-columns: 15% 65% 20%;\n  width: 100%;\n}\n\n.doc-container, \n.page-container {\n  display: grid;\n  grid-template-columns: 15% 65% 20%;\n  width: 100%;\n}\n\n.btn {\n  --tw-border-opacity: 1;\n  --tw-gradient-from: #fff;\n  --tw-gradient-to: hsla(0,0%,100%,0);\n  --tw-gradient-stops: var(--tw-gradient-from),var(--tw-gradient-to);\n  --tw-gradient-to: #f3f4f6;\n  --tw-text-opacity: 1;\n  border-color: rgb(229 231 235/var(--tw-border-opacity));\n  /* color: rgb(31 41 55/var(--tw-text-opacity)); */\n}\n\n/* .w-full {\n  width: 100%;\n} */\n\n.text-gray-400 {\n  --tw-text-opacity: 1;\n  color: rgb(156 163 175/var(--tw-text-opacity));}\n\n.mr-1\\.5 {\n    margin-right: 0.375rem;\n}\n\n.grid-cols-2 {\n  grid-template-columns: repeat(2,minmax(0,1fr));\n}\n\n.grid {\n  display: grid;\n}\n\n.content-start {\n  align-content: flex-start;\n}\n\n.gap-2\\.5 {\n  gap: 0.625rem;\n}\n\n.text-black {\n  --tw-text-opacity: 1;\n  color: rgb(0 0 0/var(--tw-text-opacity));\n}\n.bg-white {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255/var(--tw-bg-opacity));\n}\n.flex-col {\n  flex-direction: column;\n}\n.min-h-screen {\n  min-height: 100vh;\n}\n.flex {\n  display: flex;\n}\n.inside-body {\n  line-height: inherit;\n  margin: 0;\n}\n\n.contents {\n  display: contents;\n}\n\n.border-gray-100 {\n  --tw-border-opacity: 1;\n  border-color: rgb(243 244 246/var(--tw-border-opacity));\n}\n.border-y {\n  border-bottom-width: 1px;\n}\n\n.px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.h-16 {\n  height: 4rem;\n}\n\n.container {\n  margin-left: auto;\n  margin-right: auto;\n  /* padding-left: 1rem;\n  padding-right: 1rem; */\n  width: 100%;\n}\n\n.flex-1 {\n  flex: 1 1 0%;\n}\n\n.flex-none {\n  flex: none;\n}\n\n.mr-5 {\n  margin-right: 1.25rem;\n}\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n\n/*\nStyles for Right Rail\n*/\n\n.display-flex .text-container {\n  padding-left: 3px;\n  padding-top: 2px;\n}\n\n.results-window .font-size {\n  font-size: 12px;\n}\n\n.display-flex {\n  display: flex;\n}\n.display-flex p{\nmargin: 0px;}\n\n.time-stamp-display {\n  float: left;\n  font-size: 12px;\n  padding-left: 28px;\n}\n\n.right-rail-search-svg {\n  padding: 5px;\n  \n}\n\n.right-side-of-container svg {\n  padding-right: 20px;\n}\n\n.row5-search-window svg {\n  padding-right: 20px;\n}\n.row3-search-window {\n  padding-bottom: 25px !important;\n}\n.row5-search-window {\n  background-color: #dee2e6!important;\n}\n\n.row1-search-window, .row3-search-window, .row4-search-window, .row5-search-window {\n  display: flex;\n  justify-content: space-between;\n}\n\n.storage-span {\n  margin-top: 4px;\n}\n\n.results-window{\n  /* border: 1px solid black; */\n  height: 480px\n}\n\nsvg {\n  cursor: pointer;\n  vertical-align: middle;\n  /* --tw-text-opacity: 1;\n    color: rgb(156 163 175/var(--tw-text-opacity)); */\n}\n\n.svg-inline--fa {\n  height: 0.8rem;\n  color: #25537b;\n  font-weight: 400;\n}\n\n.right-container {\n  position: sticky;\n    top: 0;\n}\n\n.rightpane-text {\n  color: #2c3143;\n    font-weight: 400;\n    line-height: 1.2;\n}\n\n.rightpane-text-history {\n  font-size: 1.0625rem;\n  font-weight: 500;\n}\n\n.rightpane-text-unnamed-history {\n  font-size: 1.275rem;\n}\n\n/* .row5-search-window .left-side-of-container, .row4-search-window .left-side-of-container{\n  padding-left: 0.8rem;\n} */\n.row1-search-window .left-side-of-container{\n  padding-top: 5px;\n}\n\n.row3-search-window .left-side-of-container{\n  padding-top: 3px;\n}\n\n.row4-search-window .left-side-of-container{\n  display: flex;\n}\n\n.rightpane-1 svg:hover {\n  background-color: #c8cfd6;\n}\n\n/* .rightpane-1 svg{\n  padding: 10px;\n} */\n\n.rightpane-1 svg:not(.search-icon-svg) {\n  padding: 10px;\n}\n\n.input-group {\n  align-items: stretch;\n  display: flex;\n  flex-wrap: wrap;\n  position: relative;\n  width: 100%;\n}\n\n.input-group .form-control {\n  flex: 1 1 auto;\n  margin-bottom: 0;\n  min-width: 0;\n  position: relative;\n  width: 1%;\n  font-size: .85rem;\n  line-height: 1.5;\n  background-clip: padding-box;\n  background-color: #fff;\n  border: 1px solid #bdc6d0;\n  color: #2c3143;\n  display: block;\n}\n\n.form-control-sm {\n  border-radius: 0.2rem;\n  font-size: .74375rem;\n  height: 22px;\n  line-height: 1.5;\n  padding: 0.25rem 0.5rem;\n}\n\n.input-group-append {\n  margin-left: -1px;\n}\n\n.input-group-append, .input-group-prepend {\n  display: flex;\n}\n.btn-secondary{\n  border: 1px solid #bdc6d0;\n  padding: 7px;\n  cursor: pointer;\n}\n.rows-search-window {\n  padding-bottom: 5px;\n}\n\n.btn-secondary:hover{\n  background-color: #c8cfd6;\n}\n\n.alert-info, .form-help .note, .infomessage, .infomessagelarge, .infomessagesmall {\n  background: #daecf8!important;\n}\n\n.alert-info{\n  border-color: transparent;\n  color: #2a3f59;\n}\n.alert {\n  border: 1px solid transparent;\n    border-radius: 0.25rem;\n    margin-bottom: 1rem;\n    padding: 0.75rem 1.25rem;\n    position: relative;\n}\n.m-2 {\n  margin: 0.5rem!important;\n}\n.results-window h4 {\n  margin: 5px;\n}\n\n.results-window p {\nfont-size: 14px;}\n/*\nStyles for Login page\n\n*/\n\n\n.form-input:not([type=radio]):not([type=checkbox]) {\n  border-radius: 0.375rem;\n  display: block;\n  margin-top: 0.25rem;\n  width: 100%;\n}\n\n.form-input:not([type=checkbox]) {\n  --tw-shadow: 0 1px 2px 0 rgba(0,0,0,.05);\n  --tw-shadow: 0 1px 2px 0 rgba(0,0,0,.05);\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-border-opacity: 1;\n  border-color: rgb(229 231 235/var(--tw-border-opacity));\n  border-width: 2px;\n  --tw-ring-shadow: 0 0 #0000;\n    \n}\n\n.auth-form-container a {\n  color: #169BD5;\n  text-decoration: none;\n  font-size: small;\n}\n\n.comn-container-auth{\n    position: absolute;\n    z-index: 899;\n    left: 25%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    width: 50%;\n    margin-top: 50px;\n    background-color: #fff;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);\n}\n\n.comn-container-auth p {\n  margin-bottom: 30px !important;\n}\n\n.comn-container-auth h1, .comn-container-auth p {\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.comn-container-auth label {\n  display: block;\n  margin-bottom: 5px;\n  margin-top: 20px;\n}\n\n.comn-container-auth input[type=\"checkbox\"] {\n  height: 13px;\n}\n\n.comn-container-auth input{\n  display: block;\n  /* margin-bottom: 25px; */\n  height: 35px;\n  border-radius: 6px;\n  border: 1px solid;\n  width: 100%;\n  padding: 0.2rem 0.5rem;\n}\n\n/* .comn-container-auth button {\n  margin-top: 25px;\n  margin-top: 10px;\n  margin: 25px 0px 0px 80px;\n  height: 45px;\n  border-radius: 6px;\n  border: 1px solid;\n  width: 40%;\n} */\n.comn-container-auth button {\n  --tw-border-opacity: 1;\n  --tw-gradient-from: #fff;\n  --tw-gradient-to: hsla(0,0%,100%,0);\n  --tw-gradient-stops: var(--tw-gradient-from),var(--tw-gradient-to);\n  --tw-gradient-to: #f3f4f6;\n  --tw-text-opacity: 1;\n\n}\n.btn-widget {\n  border-color: rgb(229 231 235/var(--tw-border-opacity));\n  color: rgb(31 41 55/var(--tw-text-opacity));\n  width: 100%;\n  align-items: center;\n  /* background-image: linear-gradient(to bottom,var(--tw-gradient-stops)); */\n  border-radius: 0.5rem;\n  border-width: 1px;\n  cursor: pointer;\n  display: inline-flex;\n  justify-content: center;\n  padding: 1rem 0.75rem;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  white-space: nowrap;\n  margin-top: 2rem !important;\n\n}\n\n\n.comn-container-auth form {\n  flex-direction: column;\n}\n\n.inner-container-auth{\n  width: 40%;\n}\n\n.clear-icon {\n    position: absolute;\n    right: 12px !important;\n    top: 8px !important;\n    cursor: pointer;\n}\n.checkbox-container {\n  display: flex;\n}\n\n.checkbox-container a {\n  padding-left: 55px;\n}\n\n.checkbox-container label {\n  margin-top: -3px;\n  margin-bottom: 0px;\n}\n\n.span-class-link {\n  color: #169BD5;\n  cursor: pointer;\n  font-size: small;\n}\n\n.checkbox {\n  display: flex;\n  margin-top: 1rem;\n}\n\n.checkbox input[type=\"checkbox\"] {\n  margin-right: 5px;\n  width: auto;\n}\n\n.checkbox label {\n  margin-top: -2px;\n}\n\n.checkbox span{\n  margin-left: 3rem;\n}\n\n\n\n\n/* Styles for team Page */\n\n.img-responsive {\n  display: block;\n  height: auto;\n  width: 180px;\n  height: 181px;\n}\n\n.team-page-container a {\n  color: #169BD5;\n}\n\n.image-container p {\n  margin: 2px;\n}\n\n.team-page-container h3 {\n  font-size: 34px;\n  margin-top: 20px;\n  margin-bottom: 0px;\n}\n.team-page-container h1 {\n  font-size: 56px;\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.team-page-container h1, .team-page-container h3 {\n  color: #444;\n}\n\n.member-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 230px; \n  padding: 20px;\n  border-top: 1px solid #ccc;\n}\n\n.member-image {\n  width: 155px;\n  height: auto;\n  object-fit: cover;\n  margin-bottom: 20px;\n}\n\n.member-details {\n  text-align: center;\n}\n\n.member-name {\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.member-organization {\n  font-size: 1rem;\n}\n\n.core-team-container, .steering-team-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.steering-committee-header3 {\n  margin-bottom: 15px !important;\n}\n\n\n\n/* Styles for Nav Links */\n\n.hide {\n  display: none;\n}\n\nul.ul-suboptions {\n  display: list-item;\n  /* background-color: #333; */\n  padding: 2px;\n  /* margin-left: -24px; */\n}\nul.ul-suboptions li {\n  padding: 10px 20px;\n  text-align: center;\n  max-width: 10rem;\n}\nul.ul-suboptions li:hover {\n  background-color: rgba(128, 128, 128, 0.06);\n  text-decoration: underline;\n  text-decoration-color: black;\n}\n\n.suboptions-container {\n  position: absolute;\n  z-index: 1999;\n  background-color: white;\n}\n\nul li:hover > ul {\n  display: list-item !important;\n}\n\n/* Styles for Main-content */\n\n.main-content img{\n  max-width: 95%;\n  max-height: 100%;\n}\n/* .main-content h2{\n  text-align: center;\n} */\n\n.main-content a{\n  color: #111849;\n  text-decoration: underline;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.main-content li{\n  list-style-type: disc;\n}\n.main-content ul{\n  list-style-type: disc;\n  padding-left: 3rem;\n}\n\n.main-content code {\n  font-size: 85%;\n  /* background-color: rgba(175, 184, 193, 0.2); */\n  padding: 0.2em 0.4em;\n  margin: 0px;\n  border-radius: 6px;\n  font-family: monospace;\n  font-size: 12px;\n\n}\n\n.main-content pre {\n  font-size: 85%;\n  line-height: 1.45;\n  background-color: rgb(246, 248, 250);\n  overflow-wrap: normal;\n  padding: 16px;\n  overflow: auto;\n  border-radius: 6px;\n  display: block;\n  font-family: monospace;\n  white-space: pre;\n  margin: 1em 0px;\n}\n\n\n/* Preview Datasets */\n\n.main-content code{\n  font-size: 14px;\n  }\n  /* .copy-to-clipboard-button {\n    position: absolute;\n    right: 0;\n    top: 0;\n    visibility: hidden;\n  } */\n  .preview-dataset-container span.fu {\n    color: #06287e;\n} \n\n\n.main-content-no-scroll img {\n  max-width: 95%;\n  max-height: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n/* .main-content-no-scroll h2{\n  text-align: center;\n} */\n\n.main-content-no-scroll a {\n  color: #111849;\n  text-decoration: underline;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.main-content-no-scroll li {\n  list-style-type: disc;\n}\n\n.main-content-no-scroll ul {\n  list-style-type: disc;\n  padding-left: 3rem;\n}\n\n.main-content-no-scroll code {\n  font-size: 85%;\n  /* background-color: rgba(175, 184, 193, 0.2); */\n  padding: 0.2em 0.4em;\n  margin: 0px;\n  border-radius: 6px;\n  font-family: monospace;\n  font-size: 12px;\n\n}\n\n.main-content-no-scroll pre {\n  font-size: 85%;\n  line-height: 1.45;\n  background-color: rgb(246, 248, 250);\n  overflow-wrap: normal;\n  padding: 16px;\n  overflow: auto;\n  border-radius: 6px;\n  display: block;\n  font-family: monospace;\n  white-space: pre;\n  margin: 1em 0px;\n}\n\n\n/* Preview Datasets */\n\n.main-content-no-scroll code {\n  font-size: 14px;\n}\n\n\n/* .copy-to-clipboard-button {\n    position: absolute;\n    right: 0;\n    top: 0;\n    visibility: hidden;\n  } */\n.preview-dataset-container span.fu {\n  color: #06287e;\n}\n\n.preview-dataset-container span.ot {\n  color: #007020;\n}\n\nspan.st {\n  color: #4070a0;\n}\n\nspan.at {\n  color: #7d9029;\n}\n\nspan.dv {\n  color: #40a070;\n}\n\nspan.sc {\n  color: #4070a0;\n}\n    \n/* Alerts */\n.message-box{\n  display: flex;\n  position: absolute;\n  z-index: 9998;\n  left: 35%;\n  /* display: inline; */\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 2px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 30%;\n  margin-top: 50px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);\n}\n\n/* Styles for\nUpdates Page */\n\n.updates-div {\n  margin: 20px 0px;\n  border-top-width: 3px;\n}\n\n\n.getStarted-container .main-content img{\n  align-items: center;\n  justify-content: center;\n}\n\n.category {\n  border-left-width: 4px;\n  border-left-color: #e9ecef;\n}\n\n#root_clustering, #root_outliers, #root_tSNEAndFR, #root_extraParameters, #root_parameters {\n  padding: 0px;\n  margin: 0px;\n}\n\n#root_clustering legend, #root_outliers legend, #root_tSNEAndFR legend, #root_extraParameters legend, #root_parameters legend{\n  background: #e9ecef  ;\n  width: 100%;\n  padding: 10px 10px;\n  font-weight: bolder;\n  color: #2c3143;\n}\n\n.tools-container .btn-info {\n  color: #fff;\n  background-color: #5bc0de;\n  border-color: #46b8da;\n}\n\n.tools-container .btn-danger {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n  /* padding: 6px 10px !important; */\n}\n\n.tools-container .btn {\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  /* flex: none !important; */\n}\n\n.tools-container .glyphicon {\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  font-family: 'Glyphicons Halflings';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.tools-container .glyphicon-plus:before {\n  content: \"\\002b\";\n}\n\n.tools-container .glyphicon-remove:before {\n  content: \"\\00d7\";\n}\n\n.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0;\n}\n.btn-group .btn+.btn, .btn-group .btn+.btn-group, .btn-group .btn-group+.btn, .btn-group .btn-group+.btn-group {\n  margin-left: -1px;\n}\n.btn-group-vertical>.btn.active, .btn-group-vertical>.btn:active, .btn-group-vertical>.btn:focus, .btn-group-vertical>.btn:hover, .btn-group>.btn.active, .btn-group>.btn:active, .btn-group>.btn:focus, .btn-group>.btn:hover {\n  z-index: 2;\n}\n\n.btn-default:hover {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.btn.focus, .btn:focus, .btn:hover {\n  color: #333;\n  text-decoration: none;\n}\n.btn-default {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc !important;\n}\n.glyphicon-arrow-down:before {\n  content: \"\\2193\";\n}\n.glyphicon-arrow-up:before {\n  content: \"\\2191\";\n}\n\n.tools-container .btn-danger:hover {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #ac2925;\n}\n\n.sub-category {\n  margin-left: 10px;\n}\n.field-object .form-subset {\n  border-left-width: 4px;\n  border-left-color: #e9ecef;\n}\n\n.field-object .form-subset fieldset{\n  padding: 0px;\n}\n\n.field-object .form-subset legend{\n  margin-left: -3px;\n}\n.control-label {\n  font-weight: bolder;\n}\n\n.default-class {\n  margin-left: 10px;\n}\n\n.default-class label{\n  background: #e9ecef  ;\n  width: 100%;\n  padding: 10px 10px;\n  font-weight: bolder;\n}\n\n.default-class select,\n.default-class p{\n  margin-left: 10px;\n  width: 98.5% !important;\n}\n\n/* .field-description {\n  padding-left: 10px;\n} */\n\n.common-class-tools-and-workflows .form-group {\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n}\n\n.common-class-tools-and-workflows .form-component label {\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n.common-class-tools-and-workflows .form-component input,\n.common-class-tools-and-workflows .form-component select,\n.common-class-tools-and-workflows .form-component textarea {\n    display: block;\n    width: 100%;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  }\n/* \n  .common-class-tools-and-workflows .form-component select.form-control {\n    height: 40px;\n  } */\n\n  .common-class-tools-and-workflows .form-component select option {\n    padding: 5px; /* Add some padding to each option */\n    margin: 5px 0;\n  }\n\n  .common-class-tools-and-workflows .inputData-management .datasets-input-select ul {\n    padding-left: 0px;\n  }\n\n  .datasets-input-select {\n    width: 100%;\n  }\n\n  .datasets-input-select select {\n    overflow: auto;\n  }\n\n  .common-class-tools-and-workflows .form-component input:focus,\n  .common-class-tools-and-workflows .form-component select:focus,\n  .common-class-tools-and-workflows .form-component textarea:focus {\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  }\n\n  .inputData-management {\n    margin-left: 15px;\n  }\n\n  .inputData-management .icons-wrap-input {\n    margin-right: 10px;\n  }\n\n  .inputData-management .icons-wrap-input button.database-icon-input{\n    border: 1px solid #bdc6d0;\n    padding: 7px 10px;\n    margin-right: 5px;\n  }\n  .inputData-management .icons-wrap-input svg{\n    /* background-color: rgb(218, 236, 248); */\n    background-color: rgba(218, 236, 248, 0);\n  }\n\n  /* .inputData-management .icons-wrap-input{\n    background-color: rgb(218, 236, 248);\n    border-radius: 5px;\n    border: 1px solid #bdc6d0;\n  } */\n\n  /* .inputData-management .icons-wrap-input button{\n    background-color: rgb(218, 236, 248);\n    border: 1px solid #bdc6d0;\n    padding: 7px 10px;\n    margin-left: -1px;\n    cursor: pointer;\n  } */\n  .inputData-management button.input-path-button {\n    padding: 7px 10px;\n    background-color: #dee2e6;\n    border-radius: 5px;\n    border: 1px solid #bdc6d0;\n  }\n\n  .inputData-management button.input-path-button svg{\n    background-color: #dee2e6;\n  }\n\n  .inputData-management #upload-data-div{\n    background-color: rgb(218, 236, 248);\n  }\n\n  .inputData-management #upload-data-div select{\n    background-color: rgb(218, 236, 248);\n    display: block;\n    float: none;\n    margin-right: 26px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 94%;\n    cursor: pointer;\n  }\n\n.ui-form-title-message {\n    color: #545e81;\n    cursor: default;\n    font-size: .595rem;\n    font-weight: 300;\n    vertical-align: text-top;\n}\n\n  .inputData-management .wrap-div-row {\n    display: flex;\n  }\n\n  .inputData-management .common-row-wrap {\n    padding-top: 2px;\n    }\n\n  .common-class-tools-and-workflows .form-component button[type=\"submit\"] {\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff;\n    display: inline-block;\n    font-weight: 400;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    border: 1px solid transparent;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    border-radius: 0.25rem;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  }\n\n  .common-class-tools-and-workflows .form-component button[type=\"submit\"]:hover {\n    color: #fff;\n    background-color: #0069d9;\n    border-color: #0062cc;\n  }\n  .common-class-tools-and-workflows .separator, .upload-task .separator{\n    align-items: center;\n    display: grid;\n    grid-template-columns: 1rem auto 1fr;\n    margin-bottom: 0.5rem;\n    gap: 1rem;\n  }\n\n  .common-class-tools-and-workflows .separator .stripe, .upload-task .separator .stripe {\n    background-color: rgb(222, 226, 230);\n    display: block;\n    height: 1px;\n}\n\n.common-class-tools-and-workflows .h-sm, .upload-task .h-sm {\n  line-height: 1.2;\n  font-weight: 700;\n  font-size: 1.0625rem;\n}\n\n\n\n.panel-icons {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: flex;\n  gap: 5px;\n  height: 100%;\n  padding: 10px;\n  font-size: 20px;\n}\n\n.panel-icons svg {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n/* .tool-panel-section {\n  padding-bottom: 0.25rem;\n  padding-left: 0.75rem;\n  padding-top: 0.25rem;\n} */\n\n/* \n.tool-panel-section h3 {\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  background: rgb(233, 236, 239);\n  border-left: 0.25rem solid rgb(174, 185, 197);\n} */\n\n.category-level-header {\n  padding: 10px 0px 10px 15px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  background: rgb(233, 236, 239);\n  border-left: 0.25rem solid rgb(174, 185, 197);\n  margin: 0px;\n  cursor: pointer;\n}\n\n/* .filter-level-ul {\n  padding: 0px 0px 0px 15px;\n} */\n\n.category-level {\n  margin-bottom: 20px;\n}\n\nli.filter-level-li {\n  padding: 11px 0px;\n  padding-left: 40px;\n  word-break: break-word;\n  cursor: pointer;\n}\n\n.category-icon {\n  float: right;\n  margin-right: 10px;\n}\n\n/* .category-filters {\n  overflow: hidden;\n  transition: all 5s ease-in-out;\n  max-height: 0;\n  opacity: 0;\n}\n\n.category-filters.expanded {\n  max-height: 500px;\n  opacity: 1;\n} */\n\n\n/* Define the animation */\n@keyframes expand {\n  0% {\n    height: 0;\n    opacity: 0;\n  }\n  100% {\n    height: 50px;\n    opacity: 1;\n  }\n}\n\n/* Apply the animation to the ul element */\n.filter-level-ul {\n  overflow: hidden;\n  animation: expand 0.2s ease-out;\n}\n\n.category-level-header:hover {\n  background-color: #e0e0e0;\n}\n\n.filter-level-li:hover {\n  background-color: #f0f0f0;\n}\n\nwidth\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n/* ::-webkit-scrollbar-track {\n  background: #f1f1f1; \n}\n \n::-webkit-scrollbar-thumb {\n  background: #888; \n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555; \n} */\n\n.left-nav-background {\n  background: #f8f9fa;\n}\n\n.tool-message {\n  padding: 10px;\n}\n\n/* .filter-details-tools {\n  margin: 10px 20px 10px 10px;} */\n\n\n  \n.expandable {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-bottom: 10px;\n}\n\n.header {\n  background-color: #f5f5f5;\n  padding: 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.arrow {\n  display: inline-block;\n  width: 20px;\n  text-align: center;\n  transition: transform 0.3s;\n}\n\n.arrow.expanded {\n  transform: rotate(90deg);\n}\n\n.title {\n  margin-left: 5px;\n}\n\n.content {\n  padding: 10px;\n  animation: slide-down 0.3s ease;\n}\n\n@keyframes slide-down {\n  0% {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.hoverable-icon {\n  position: relative;\n  display: inline-block;\n  background-color: transparent;\n  color: black;\n  border-radius: 50%;\n  padding: 5px;\n  transition: background-color 0.3s ease;\n}\n\n.hoverable-icon:hover {\n  background-color: lightgrey;\n}\n\n\n.publish-dataset-div .toggle-switch {\n  position: relative;\n  width: 75px;\n  display: inline-block;\n  text-align: left;\n  top: 8px;\n}\n.publish-dataset-div .checkbox {\n  display: none;\n}\n.publish-dataset-div .label {\n  display: block;\n  overflow: hidden;\n  cursor: pointer;\n  border: 0 solid #bbb;\n  border-radius: 20px;\n}\n.publish-dataset-div .inner {\n  display: block;\n  width: 200%;\n  margin-left: -100%;\n  transition: margin 0.3s ease-in 0s;\n}\n.publish-dataset-div .inner:before,\n.publish-dataset-div .inner:after {\n  float: left;\n  width: 50%;\n  height: 36px;\n  padding: 0;\n  line-height: 36px;\n  color: #fff;\n  font-weight: bold;\n  box-sizing: border-box;\n}\n.publish-dataset-div .inner:before {\n  content: \"YES\";\n  padding-left: 10px;\n  background-color: #060;\n  color: #fff;\n}\n.publish-dataset-div .inner:after {\n  content: \"NO\";\n  padding-right: 10px;\n  background-color: #bbb;\n  color: #fff;\n  text-align: right;\n}\n.publish-dataset-div .switch {\n  display: block;\n  width: 24px;\n  margin: 5px;\n  background: #fff;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 40px;\n  border: 0 solid #bbb;\n  border-radius: 20px;\n  transition: all 0.3s ease-in 0s;\n}\n.publish-dataset-div .checkbox:checked + .label .inner {\n  margin-left: 0;\n}\n.publish-dataset-div .checkbox:checked + .label .switch {\n  right: 0px;\n}\n\n\n#dashFrame{\n  height: 100vh;\n}\n\n\n.eighty-twenty-grid {\n  display: grid;\n  grid-template-columns: 80% 20%;\n}\n\n\n\n.eighty-twenty-grid .main-content{\n  margin-left: 4rem;\n}\n\n.eighty-twenty-grid .main-content .task-builder-task{\n  margin-top:2rem;\n}\n\n.eighty-twenty-grid .main-content-no-scroll .task-builder-task {\n  margin-top: 2rem;\n}\n\n/* popupmodal.css */\n.session-manager-component .modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0,0,0,0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 995;\n}\n\n.session-manager-component .modal-content {\n  background: white;\n  padding: 40px;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  width: 400px;\n  max-width: 90%;\n  height: inherit;\n}\n\n.session-manager-component .modal-message {\n  font-size: 18px;\n  line-height: 1.5;\n  margin: 0 0 20px;\n}\n\n.session-manager-component .modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.session-manager-component .modal-button {\n  background: #4CAF50;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.session-manager-component .modal-button.no {\n  background: #f44336;\n}\n\n\n.MuiTypography-h6,.MuiTypography-body1  {\n  font-size: 15px !important;\n}\n\n\n\n\n/* Live logs */\n\n.text-red-500 {\n  color: #EF4444; \n}\n\n.text-yellow-400 {\n  color: #FACC15; \n}\n\n.text-green-500 {\n  color: #22C55E;\n}\n\n\n\n/* .dark-bg {\n  background-color: #1F2937;\n}\n\n.flex-center {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 0.75rem;\n}\n\n.title {\n  font-size: 1.875rem; \n  color: #D1D5DB; \n}\n\n.log-box {\n  display: block;\n  width: 100%;\n  padding: 0.625rem; \n  font-size: 0.875rem; \n  color: #1F2937; \n  background-color: #F9FAFB;\n  border-radius: 0.375rem; \n  border: 1px solid #E5E7EB;\n}\n\n.log-box:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n  border-color: #3B82F6; \n}\n\n.dark .dark-bg {\n  background-color: #374151;\n}\n\n.dark .log-box {\n  background-color: #374151; \n  border-color: #4B5563; \n  color: #F9FAFB; \n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
